import { CREATE_ORDER, GET_STORE_PRODUCTS_AVAILABLE } from './ApiConstants';
import api from './ApiHandler';

export const getOrderssList = async ({
  page,
  limit,
  entityId
}: {
  page: number;
  limit: number;
  entityId: any;
}) => {
  return await api.get('/get-orders', { params: { page, limit, entityId } });
};

export interface CreateOrdersPayloads {
  orderBy: string;
  totalAmount: number;
  note: string;
  requestedDeliveryDate: string;
  poNumber: string;
  status: string;
  categoryId: number;
  subCategoryId: number;
  quantity: number;
  productId: number;
  price: number;
  productName: string;
}

export const createOrder = async (payload: CreateOrdersPayloads) => {
  return await api.post(CREATE_ORDER, { ...payload });
};

export const getCreateOrdersByPage = async (payload: any) => {
  return await api.get(GET_STORE_PRODUCTS_AVAILABLE, { params: payload });
};
